// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__XIOwo","meals-appear":"AvailableMeals_meals-appear__IRYQb"};